import { useState, ChangeEvent, useRef } from "react"
import Button from "../../component/button/button"
import { IoArrowBack } from "react-icons/io5"
import { useLocation, useNavigate } from "react-router-dom"
import CustomInput from "src/component/CustomInput/CustomInput"
import { verifyOtp } from "src/api/auth"

const OtpPassword = () => {
  const [otp, setOtp] = useState(["", "", "", "", "", ""])
  const [loading, setLoading] = useState(false)
  const inputsRef = useRef<Array<HTMLInputElement | null>>([])
  const navigate = useNavigate()
  const location = useLocation()

  const handleChange = (value: string, index: number) => {
    // Only allow digits
    if (/^\d$/.test(value)) {
      const newOtp = [...otp]
      newOtp[index] = value
      setOtp(newOtp)

      // Auto-focus next input
      if (index < otp.length - 1) {
        setTimeout(() => {
          const nextInput = inputsRef.current[index + 1]
          if (nextInput) nextInput.focus()
        }, 0)
        console.log("this is data", inputsRef.current[index])

        inputsRef.current[index]?.blur()
        inputsRef.current[index + 1]?.focus()
      }
    } else if (value === "") {
      const newOtp = [...otp]
      newOtp[index] = ""
      setOtp(newOtp)
    }
  }

  const handleKeyDown = (
    e: React.KeyboardEvent<HTMLInputElement>,
    index: number
  ) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      // If empty and backspace → go to previous
      inputsRef.current[index - 1]?.focus()
    }
  }

  const handleFocus = (index: number) => {
    // Prevent skipping: if earlier fields are empty → jump back
    const firstEmptyIndex = otp.findIndex((digit) => digit === "")
    if (firstEmptyIndex !== -1 && firstEmptyIndex < index) {
      inputsRef.current[firstEmptyIndex]?.focus()
    }
  }

  const handlePaste = (
    e: React.ClipboardEvent<HTMLInputElement>,
    index: number
  ) => {
    e.preventDefault()
    const paste = e.clipboardData.getData("Text").trim()
    if (!/^\d+$/.test(paste)) return // only digits

    const newOtp = [...otp]
    for (let i = 0; i < paste.length && index + i < otp.length; i++) {
      newOtp[index + i] = paste[i]
    }
    setOtp(newOtp)

    // Focus next empty input
    const nextIndex = index + paste.length
    if (nextIndex < otp.length) {
      inputsRef.current[nextIndex]?.focus()
    }
  }

  const handleSubmit = (e: any) => {
    if (loading) return
    e.preventDefault()
    const enteredOtp = otp.join("")
    const email = location.state?.email
    setLoading(true)
    verifyOtp(email, enteredOtp)
      .then((res) => {
        navigate("/set-password", {
          state: { email, token: res?.data?.data?.gtoken },
        })
      })
      .catch((err) => {
        console.log({ err })
      })
      .finally(() => {
        setLoading(false)
      })
  }

  return (
    <div className='content login'>
      <div className='login_container'>
        <h2 className='title'>Password reset</h2>
        <p>We sent a code to your email</p>

        <form onSubmit={handleSubmit} className='otp_form'>
          <div className='otp_inputs flex justify-center gap-3'>
            {otp.map((digit, index) => (
              <CustomInput
                key={index}
                placeholder=''
                maxLength={1}
                value={digit}
                style={{ width: 80, textAlign: "center", fontSize: 24 }}
                onChange={(e: ChangeEvent<HTMLInputElement>) =>
                  handleChange(e.target.value, index)
                }
                onKeyDown={(e) => handleKeyDown(e, index)}
                onFocus={() => handleFocus(index)}
                onPaste={(e) => handlePaste(e, index)} // <-- Add this
                // store refs
                ref={(el) => (inputsRef.current[index] = el)}
              />
            ))}
          </div>

          <Button
            text={loading ? "Verifying" : "Verify"}
            style={{ marginTop: 12 }}
            type='secondary'
            buttonType='submit'
          />
        </form>

        <p className='no_account'>
          Didn’t receive the email?{" "}
          <span className='cursor-pointer text-blue-600'>Click to resend</span>
        </p>

        <p
          className='no_account cursor-pointer'
          onClick={() => navigate("/login")}
        >
          <IoArrowBack /> Back to log in
        </p>
      </div>
    </div>
  )
}

export default OtpPassword
